'use strict';

/** @type {import('./abs')} */
module.exports = Math.abs;



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/math-intrinsics@1.1.0/~/math-intrinsics/abs.js
// module id = 750
// module chunks = 0